module.exports = __webpack_public_path__ + "img/pic_logo_down@2x.0a40ac0b.png";